module.exports = __webpack_public_path__ + "static/img/audio_poster.71524a2.png";